import React from 'react';
import env from '../../environment';

const IconWrong = () => {
  if (env.appEnv === 'dev' || env.appEnv === 'local') {
    return <img style={{ width: 20, height: 20 }} src={env.images.icon.wrongFeo} />;
  }
  return (
  <i
    className="fa fa-times"
    aria-hidden="true"
    style={{
      color: env.colors.error,
      marginRight: 10,
    }}
  />
)};

export default IconWrong;
